import { Empty, PageHeader, Popconfirm, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, ButtonItem } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import AgregarDoctor from "./AgregarDoctor/AgregarDoctor";
import EditarDoctor from "./EditarDoctor/EditarDoctor";

moment.locale("es");

class Doctores extends Component {
  state = {
    modalAgregar: false,
    modalEditar: false,
    todosDoctores: [],
    loading: false,
    doctorId: null,
  };

  // Abrir modal para agregar
  abrirAgregarDoctor(){
    this.setState({ modalAgregar: true, doctorId: null });
  };

  // Cerrar modal de agregar
  cerrarAgregarDoctor(){
    this.setState({ modalAgregar: false });
    this.consultarTodosDoctores();
  };

  // Abrir modal para editar
  abrirEditarDoctor(doctorId){
    this.setState({ modalEditar: true, doctorId: doctorId });
  };

  // Cerrar modal de editar
  cerrarEditarDoctor(){
    this.setState({ modalEditar: false });
    this.consultarTodosDoctores();
  };

  componentDidMount() {
    this.consultarTodosDoctores();
  }

  consultarTodosDoctores() {
    this.setState({ loading: true });
    axios
      .post(
        "doctores/selectTodosDoctores",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            todosDoctores: res.data.doctores
          });
        } else {
          message.error("Error no se encotraron doctores");
        }
      });
  }

  // Deshabilita un Doctor 
  deshabilitarDoctor(id) {
    axios
      .post(
        "doctores/deshabilitarDoctor",
        { doctorId: id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Doctor deshabilitado exitosamente");
          this.consultarTodosDoctores();
        } else if (res.data.success === 1){
          message.error("Error al deshabilitar el doctor");
        }else{
          message.error("Error");
        }
      });
  }

  // Habilita un doctor
  habilitarDoctor(id) {
    axios
      .post(
        "doctores/habilitarDoctor",
        { doctorId: id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Doctor habilitado exitosamente");
          this.consultarTodosDoctores();
        } else if (res.data.success === 1){
          message.error("Error al habilitar el doctor");
        }else{
          message.error("Error");
        }
      });
  }

  render() {
    const columns = [
      {
        title: "Código",
        dataIndex: "codigo",
        key: "codigo",
        sorter: (a, b) => {
          if (a.codigo < b.codigo) {
            return -1;
          }
          if (a.codigo > b.codigo) {
            return 1;
          }
          return 0;
        },
        buscar: "codigo",
      },
      {
        title: "Nombre del Doctor",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
        buscar: "nombre",
      },
      {
        title: "Especialidad",
        dataIndex: "especialidad",
        key: "especialidad",
        sorter: (a, b) => {
          if (a.especialidad < b.especialidad) {
            return -1;
          }
          if (a.especialidad > b.especialidad) {
            return 1;
          }
          return 0;
        },
        buscar: "especialidad",
      },
     {
        title: "Acción",
        key: "accion",
        align: "center",
        width: "20%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (record, index) => {
          let buttons = [];

          buttons.push(
            <Tooltip 
              title="Editar Doctor" 
              placement="top" 
              overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
            >
              <ButtonItem
                key={`editar-${index}`}
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => this.abrirEditarDoctor(record._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          if (record.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`deshabilitar-${index}`}
                title="¿Seguro que quieres deshabilitar este doctor?"
                onConfirm={() => this.deshabilitarDoctor(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip 
                  title="Deshabilitar" 
                  placement="top" 
                  overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm
                key={`habilitar-${index}`}
                title="¿Seguro que quieres habilitar este doctor?"
                onConfirm={() => this.habilitarDoctor(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip 
                  title="Habilitar" 
                  placement="top" 
                  overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      }
    ];

    return (
      <>
        <PageHeader
          title="Doctores"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <ButtonItem
              type="primary"
              key="agregarDoctor"
              olivo
              onClick={this.abrirAgregarDoctor.bind(this)}
               className="botonAgregar"
            >
              Agregar Doctor
            </ButtonItem>
          }
        />
        <TableItem
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <>
                    <p>
                      No hay registros de doctores. Aquí puedes gestionar y
                      llevar un control de los doctores.
                    </p>
                  </>
                }
              />
            ),
          }}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todosDoctores}
          columns={columns}
          pagination={false}
        />
        <AgregarDoctor
          visible={this.state.modalAgregar}
          cerrarAgregarDoctor={this.cerrarAgregarDoctor.bind(this)}
        />
        <EditarDoctor
          visible={this.state.modalEditar}
          cerrarEditarDoctor={this.cerrarEditarDoctor.bind(this)}
          doctorId={this.state.doctorId}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(Doctores);
